import { useCallback, useLayoutEffect, useRef } from 'react';

const useMemoizedFn = fn => {
  const fnRef = useRef(fn);

  useLayoutEffect(() => {
    fnRef.current = fn;
  }, [fn]);

  return useCallback(
    (...args) => fnRef.current.apply(null, args),
    [fnRef]
  );
};

export default useMemoizedFn;
